import React from "react";

import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import Page from "../../../layout/Page/Page";
import WebToPdfSection from "../../../user/components/sections/WebToPdfSection";

const GeneratePdfPage: React.FC = () => {
  return (
    <PageWrapper title="Generate PDF">
      <Page container="fluid">
        <div className="internal-generate-pdf-page">
          <WebToPdfSection showHeroHeading={false} />
        </div>
      </Page>
    </PageWrapper>
  );
};

export default GeneratePdfPage;
